<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="objectsArr"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title v-if="computedTitle">{{ computedTitle }}</v-toolbar-title>
          <v-divider
            v-if="computedTitle"
            class="mx-4"
            inset
            vertical
          />
          <v-spacer/>
          <v-dialog v-model="dialog" @click:outside="close()" max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn v-if="isSuperuser" color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
            </template>
            <v-card>
              <v-form ref="form" lazy-validation>
                <v-card-text v-if="objectIsEdit">
                  <v-card-title>
                    <span class="headline">Edit</span>
                  </v-card-title>

                  <v-col sm="12">
                    <v-select :rules="licenseEntity.app.validationRules" :items="apps" item-text="name" v-model="appId" item-value="id" @change="setModulesForApp" label="Choose apps" />
                  </v-col>

                  <v-col sm="12">
                    <v-select :items="modulesForApp" v-model="selectedModules" item-text="name" item-value="id" multiple chips label="Modules in license" />
                  </v-col>

                  <v-col sm="12">
                    <v-text-field
                      label="Custom name"
                      v-model="editedItem.customName"/>
                  </v-col>

                  <v-col sm="12">
                    <v-text-field
                      :rules="licenseEntity.appVersion.validationRules"
                      label="App Version"
                      v-model="editedItem.appVersion"/>
                  </v-col>

                  <v-dialog
                    ref="dialog"
                    v-model="modal"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="pickerDate"
                        label="Expired at"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="pickerDate"
                      first-day-of-week="1"
                      scrollable>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="clearExpiresAtDate()">Cancel</v-btn>
                      <v-btn flat color="primary" @click="setExpiresAtDateToEndOfDay(pickerDate)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>

                  <v-container>
                    <v-row v-for="(ei_value, ei_key) in editedItem" v-bind:key="ei_key" v-if="canEdit(ei_key) && ei_key !== 'customName'">
                      <v-col sm="12">
                        <v-text-field v-if="entity[ei_key].type === 'string'" v-model="editedItem[ei_key]"
                                      :label="`${ei_key}`" />
                        <v-checkbox v-if="entity[ei_key].type === 'boolean'" v-model="editedItem[ei_key]" :label="`${ei_key}`"/>
                        <div v-if="entity[ei_key].type === 'array'">
                          <v-checkbox v-for="(entity_itms_val, entity_itms_key) in entity[ei_key].allItems" v-model="editedItem[ei_key]" :label="entity_itms_val" :value="entity_itms_val" v-bind:key="entity_itms_key" />
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-text v-else>
                  <v-card-title>
                    <span class="headline">Add new item</span>
                  </v-card-title>
                  <v-container>
                    <v-row>
                      <v-col sm="12">
                        <v-select :rules="licenseEntity.app.validationRules" :items="apps" item-text="name" v-model="appId" item-value="id" @change="setModulesForApp" label="Choose apps" />
                      </v-col>

                      <v-col v-if="appId !== 0" sm="12">
                        <v-select :items="modulesForApp" v-model="selectedModules" item-text="name" item-value="id" multiple chips label="Choose modules" />
                      </v-col>

                      <v-col sm="12">
                        <v-text-field
                          label="Custom name"
                          v-model="computedObjectInput.customName"/>
                      </v-col>

                      <v-col sm="12">
                        <v-text-field
                          :rules="licenseEntity.appVersion.validationRules"
                          label="App Version"
                          v-model="computedObjectInput.appVersion"/>
                      </v-col>

                      <v-dialog
                        ref="dialog"
                        v-model="modal"
                        persistent
                        lazy
                        width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="pickerDate"
                            label="Expired at"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="pickerDate"
                          first-day-of-week="1"
                          scrollable>
                          <v-spacer></v-spacer>
                          <v-btn flat color="primary" @click="clearExpiresAtDate()">Cancel</v-btn>
                          <v-btn flat color="primary" @click="setExpiresAtDateToEndOfDay(pickerDate)">OK</v-btn>
                        </v-date-picker>
                      </v-dialog>

                      <v-container>
                        <v-row v-for="(eaf_value, eaf_key) in editAllowedFields" v-bind:key="eaf_key" v-if="canEdit(eaf_value) && eaf_value !== 'customName'">
                          <v-col sm="12">
                            <v-text-field v-if="entity[eaf_value].type === 'string'"
                                          v-model="computedObjectInput[eaf_value]"
                                          :label="eaf_value"/>
                            <v-checkbox v-if="entity[eaf_value].type === 'boolean'" v-model="computedObjectInput[eaf_value]" :label="`${eaf_value}`"/>
                            <div v-if="entity[eaf_value].type === 'array'">
                              <v-checkbox v-for="(entity_itms_val2, entity_itms_key2) in entity[eaf_value].allItems" v-model="computedObjectInput[eaf_value]" :label="entity_itms_val2" :value="entity_itms_val2" v-bind:key="entity_itms_key2" />
                            </div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer/>
                  <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                  <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.app="{ item }">
        {{ item.app.name }}
      </template>
      <template v-slot:item.permissions="{ item }">
        <div class="permissions">
          <div>
            <v-icon v-if="itemContains(item.permissions, 'superuser')" color="success">mdi-checkbox-marked-circle</v-icon>
            <v-icon v-else color="red">mdi-close-circle</v-icon> Root
          </div>
          <div>
            <v-icon v-if="itemContains(item.permissions, 'admin')" color="success">mdi-checkbox-marked-circle</v-icon>
            <v-icon v-else color="red">mdi-close-circle</v-icon> Admin
          </div>
        </div>
      </template>
      <template v-slot:item.active="{ item }">
        <div class="actions mr-8">
          <v-icon v-if="item.active" color="success">mdi-checkbox-marked-circle</v-icon>
          <v-icon v-else color="red">mdi-close-circle</v-icon>
        </div>
      </template>
      <template v-slot:item.modules="{ item }">
        <div class="modules">
          <div class="module" v-for="(module, key) in item.modules" v-bind:key="key">
            {{ module.name }}
          </div>
        </div>
      </template>
      <template v-slot:item.action="{ item }">
        <div class="actions">
          <router-link
            v-if="addLinkToDetails"
            :to="{name: `${detailsRouterName}`, params: {id: item.id}}">
            <v-icon
              class="mr-2">
              search
            </v-icon>
          </router-link>
          <v-icon
            class="mr-2 edit"
            @click="editItem(item)"/>
          <v-icon
            class="mr-2 delete"
            @click="deleteObject(item)"/>
        </div>
      </template>
      <template v-slot:no-data>
        <div class="ma-2">No data to display</div>
        <v-btn color="primary" class="mb-2" @click="getObjects">Reset</v-btn>
      </template>
    </v-data-table>

    <v-dialog max-width="290" v-model="confirmationDialog">
      <v-card>
        <v-card-title class="headline">Delete</v-card-title>

        <v-card-text>
          You are removing license for {{ appName }}.<br />
          Please confirm.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="grey"
            class="lighten-3 grey--text"
            @click="confirmationDialog = false"
          >
            Cancel
          </v-btn>

          <v-btn color="success" @click="deleteObject(editedItem, true)">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import * as dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import TypeException from '../../exceptions/TypeException';
import licenseEntity from '@/store/entity/License';

dayjs.extend(utc);

export default {
  name: 'LicensesList',
  props: ['endpoint', 'actionEndpoint', 'filters', 'entity', 'editAllowedFields', 'notDisplayedFields', 'defaultValues', 'addLinkToDetails', 'detailsRouterName', 'title'],

  data() {
    return {
      licenseEntity,
      apps: [],
      appId: 0,
      modulesForApp: [],
      selectedModules: [],
      dataObjectFields: [],
      tmpModules: [],
      objectIsEdit: undefined,
      objects: [],
      newObject: false,
      objectInput: {},
      dialog: false,
      headers: [],
      editedIndex: -1,
      editedItem: {},
      tmpPermissionsArr: [],
      confirmationDialog: false,
      modal: false,
      pickerDate: '',
    };
  },

  computed: {
    objectsArr() {
      this.objects.forEach((el) => {
        const license = el;
        if (license.expiresAt) {
          license.expiresAtFormatted = dayjs(license.expiresAt).utc(false).format('DD/MMM/YYYY HH:mm:ss');
        }
      });
      return this.objects;
    },
    computedTitle() {
      return this.title;
    },
    dataObjectFieldsToDisplayArr() {
      return this.prepareDataToDisplay(this.dataObjectFields);
    },
    computedDefaultValues() {
      return this.defaultValues;
    },
    computedObjectInput() {
      return this.objectInput;
    },
    appName() {
      return (this.editedItem.app && this.editedItem.app.name) ? this.editedItem.app.name : '';
    },
    isSuperuser() {
      return this.$store.getters['auth/isSuperuser'];
    },
  },

  methods: {
    setExpiresAtDateToEndOfDay(pickerDate) {
      this.computedObjectInput.expiresAt = dayjs(pickerDate).utc(false).endOf('day').toJSON(); // Support for CREATE ITEM

      this.editedItem.expiresAt = dayjs(pickerDate).utc(true).endOf('day').toJSON(); // Support for EDIT ITEM

      this.modal = false;
    },
    clearExpiresAtDate() {
      this.pickerDate = '';
      this.computedObjectInput.expiresAt = null;
      this.modal = false;
    },
    prepareDataToDisplay(object) {
      const newArr = [];
      object.forEach((el) => {
        if (!this.notDisplayedFields.includes(el)) {
          newArr.push(el);
        }
      });

      return newArr;
    },

    prepareTableHeaders() {
      this.headers = [];

      this.dataObjectFieldsToDisplayArr.forEach((el) => {
        const obj = {};
        obj.text = this.entity[el].displayName;
        obj.value = this.entity[el].dbKey;

        this.headers.push(obj);
      });

      this.headers.push({ text: 'Active modules', value: 'modules', sortable: false });
      if (this.isSuperuser) {
        this.headers.push({ text: 'Actions', value: 'action', sortable: false });
      }
    },

    setDefaultValues() {
      this.objectInput = { ...this.entity.mock };

      Object.keys(this.computedDefaultValues).forEach((el) => {
        const defaultVal = this.computedDefaultValues[el];
        let parsedVal;

        switch (this.entity[el].type) {
          case 'int':
            parsedVal = parseInt(defaultVal, 10);
            break;
          case 'string':
            parsedVal = defaultVal.toString();
            break;
          case 'array':
            if (typeof defaultVal !== 'object') {
              parsedVal = JSON.parse(defaultVal);
            }
            break;
          default:
            throw new TypeException('EntityList: Type error while setDefaultValues(). Not handled request field type!');
        }
        this.objectInput[el] = parsedVal;
      });
    },

    setDataObjectFields() {
      this.dataObjectFields = Object.keys(this.entity.mock);
    },

    async getObjectsBaseOnTotalItems(totalItems) {
      const querySeparator = (this.filters === '') ? '?' : '&';
      const { data } = await this.$http.get(`/${this.endpoint}${this.filters}${querySeparator}page=1&itemsPerPage=${totalItems}`, {
        headers: {
          Accept: 'application/ld+json',
        },
      });
      this.objects = data['hydra:member'];
    },

    async getObjects() {
      const { data } = await this.$http.get(`/${this.endpoint}${this.filters}`, {
        headers: {
          Accept: 'application/ld+json',
        },
      });
      const totalItems = data['hydra:totalItems'];
      await this.getObjectsBaseOnTotalItems(totalItems);
    },

    createObject() {
      delete this.computedObjectInput.id;
      delete this.computedObjectInput.app;
      this.computedObjectInput.app = `api/apps/${this.appId}`;
      this.computedObjectInput.modules = this.getPreparedModules();

      if (this.computedObjectInput.appVersion === '') {
        this.computedObjectInput.appVersion = null;
      }

      if (this.computedObjectInput.expiresAt === '') {
        this.computedObjectInput.expiresAt = null;
      }

      if (this.computedObjectInput.customName === '') {
        this.computedObjectInput.customName = null;
      }

      const endpoint = (typeof this.actionEndpoint !== 'undefined') ? this.actionEndpoint : this.endpoint;
      this.$http.post(`/${endpoint}`, this.computedObjectInput).then(async () => {
        await this.getObjects();
        this.close();
        this.$store.commit('triggerLicensesUpdate');
      });
    },

    getPreparedModules() {
      const preparedModules = [];
      this.selectedModules.forEach((moduleId) => {
        preparedModules.push(`api/modules/${moduleId}`);
      });

      return preparedModules;
    },

    updateObject() {
      const payload = { ...this.editedItem };
      const licenseId = this.editedItem.id;
      payload.modules = this.getPreparedModules();
      payload.app = `api/apps/${this.appId}`;

      const endpoint = (typeof this.actionEndpoint !== 'undefined') ? this.actionEndpoint : this.endpoint;
      if (Object.keys(payload).length > 0) {
        this.$http.patch(`/${endpoint}/${licenseId}`, payload, {
          headers: {
            'Content-Type': 'application/merge-patch+json',
          },
        }).then(() => {
          this.getObjects();
          this.close();
          this.$store.commit('triggerLicensesUpdate');
        });
      } else {
        this.close();
      }
      this.objectIsEdit = false;
    },

    deleteObject(object, confirmed = false) {
      this.editedItem = object;
      if (!confirmed) {
        this.confirmationDialog = true;
        return;
      }

      const endpoint = (typeof this.actionEndpoint !== 'undefined') ? this.actionEndpoint : this.endpoint;
      const { id } = object;
      this.$http.delete(`/${endpoint}/${id}`).then(() => {
        this.getObjects();
        this.editedItem = {};
        this.confirmationDialog = false;
        this.$store.commit('triggerLicensesUpdate');
      });
    },

    editItem(license) {
      this.prepareItemToEdit(license);
      this.dialog = true;
      this.objectIsEdit = true;
    },

    prepareItemToEdit(license) {
      this.editedItem = Object.assign({}, license);
      this.appId = license.app.id;
      this.setModulesForApp(this.appId);
      license.modules.forEach((el) => {
        this.selectedModules.push(el.id);
        this.tmpModules.push(el.id);
      });
      this.pickerDate = dayjs(license.expiresAt).utc(false).endOf('day').format('YYYY-MM-DD');

      this.editedItem.api = this.editedItem.api || '';
      this.editedItem.appVersion = this.editedItem.appVersion || '';
      this.editedItem.customName = this.editedItem.customName || '';
    },

    setModulesForApp(appId) {
      this.selectedModules = [];
      this.$http.get(`/api/modules?app.id=${appId}`).then((response) => {
        this.modulesForApp = response.data;
      });
    },

    itemContains(item, element) {
      return item.indexOf(element) > -1;
    },

    canEdit(key) {
      return this.editAllowedFields.includes(key);
    },

    canDisplay(key) {
      return !this.notDisplayedFields.includes(key);
    },

    close() {
      this.clearExpiresAtDate();
      this.tmpModules = [];
      this.dialog = false;
      this.objectIsEdit = false;
      this.setDefaultValues();
      this.resetTmpVars();
    },

    resetTmpVars() {
      this.appId = 0;
      this.modulesForApp = [];
      this.selectedModules = [];
    },

    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      if (this.objectIsEdit) {
        this.updateObject();
      } else {
        this.createObject();
      }
    },

    setApps() {
      this.$http.get('/api/apps').then((response) => {
        this.apps = response.data;
      });
    },
  },
  created() {
    this.setDefaultValues();
    this.setDataObjectFields();
    this.getObjects();
    this.prepareTableHeaders();
    if (this.$store.getters['auth/isSuperuser']) {
      this.setApps();
    }
  },
  watch: {
    'editedItem.expiresAt': function updateExpiresAtFormatted(val) {
      if (val) {
        this.editedItem.expiresAtFormatted = dayjs(val).utc(false).format('DD/MMM/YYYY HH:mm:ss');
      } else {
        // if val is empty, undefined or null
        this.editedItem.expiresAtFormatted = '';
      }
    },
  },
};
</script>

<style scoped>

</style>
